var render = function render() {
        var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;return _c('div', { staticClass: "skin-previewer-container" }, [_c('div', { staticClass: "skin-label" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.commonTemplate.previewDialog.skinLabel')) + "\n  ")]), _vm._v(" "), _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "skin-list-container" }, _vm._l(_vm.skinList, function (tag, index) {
                return _c('div', { key: tag.id, staticClass: "skin-item", class: {
                                'is-active': _vm.skinId === tag.id
                        }, on: { "click": function click($event) {
                                        return _vm.handleClick(tag);
                                } } }, [_vm._v("\n      " + _vm._s(index + 1) + "\n      "), _vm.skinId === tag.id ? _c('svg-icon', { staticClass: "icon-tick", attrs: { "icon-class": "tick", "size": 24 } }) : _vm._e()], 1);
        }), 0)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };